import React, { createContext, useContext, ReactNode } from 'react';
import posthog from '../config/posthog';

// Create a context for PostHog
const PostHogContext = createContext<typeof posthog | null>(null);

interface PostHogContextProps {
  children: ReactNode;
}

// Create a wrapper component for PostHog
export const PostHogWrapper: React.FC<PostHogContextProps> = ({ children }) => {
  return (
    <PostHogContext.Provider value={posthog}>
      {children}
    </PostHogContext.Provider>
  );
};

// Custom hook to use PostHog
export const useAnalytics = () => {
  const context = useContext(PostHogContext);
  if (!context) {
    console.warn('useAnalytics must be used within a PostHogWrapper');
    return posthog; // Return the default instance as fallback
  }
  return context;
};

export default PostHogWrapper; 